export function BicoinAuthPanel() {
  return (
    <div style={{
      width: '100%', height: '100%', borderRadius: 20,
      background: 'linear-gradient(145deg, #0a1628 0%, #0d1f3c 40%, #0a2a1f 100%)',
      display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
      padding: '40px', boxSizing: 'border-box', position: 'relative', overflow: 'hidden',
    }}>
      {/* Glow effects */}
      <div style={{ position: 'absolute', top: -60, right: -60, width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, rgba(28,212,167,0.12) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -80, left: -40, width: 350, height: 350, borderRadius: '50%', background: 'radial-gradient(circle, rgba(28,212,167,0.07) 0%, transparent 70%)', pointerEvents: 'none' }} />

      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, zIndex: 1 }}>
        <div style={{ width: 36, height: 36, borderRadius: 8, background: '#1CD4A7', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ color: '#000', fontWeight: 900, fontSize: 20, fontFamily: "'DM Sans', Arial, sans-serif" }}>B</span>
        </div>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 20, fontFamily: "'DM Sans', Arial, sans-serif", letterSpacing: '-0.3px' }}>Bicoin</span>
      </div>

      {/* Chart + stats */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, justifyContent: 'center', gap: 28, zIndex: 1 }}>
        <svg width="220" height="130" viewBox="0 0 220 130" fill="none" xmlns="http://www.w3.org/2000/svg">
          {[20,50,80,110].map(y => <line key={y} x1="10" y1={y} x2="210" y2={y} stroke="rgba(255,255,255,0.05)" strokeWidth="1" />)}
          <path d="M10,110 L40,90 L70,95 L100,60 L130,70 L160,30 L190,40 L210,25 L210,120 L10,120 Z" fill="url(#cg)" opacity="0.35" />
          <path d="M10,110 L40,90 L70,95 L100,60 L130,70 L160,30 L190,40 L210,25" stroke="#1CD4A7" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          {([[10,110],[40,90],[70,95],[100,60],[130,70],[160,30],[190,40],[210,25]] as [number,number][]).map(([x,y],i) => (
            <circle key={i} cx={x} cy={y} r="3" fill="#1CD4A7" />
          ))}
          <circle cx="160" cy="30" r="7" fill="#1CD4A7" opacity="0.2" />
          <circle cx="160" cy="30" r="3.5" fill="#1CD4A7" />
          <rect x="138" y="8" width="68" height="17" rx="5" fill="rgba(28,212,167,0.15)" />
          <text x="172" y="20" textAnchor="middle" fill="#1CD4A7" fontSize="10" fontWeight="700" fontFamily="monospace">+18.4%</text>
          <defs>
            <linearGradient id="cg" x1="110" y1="0" x2="110" y2="120" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#1CD4A7" stopOpacity="0.5" />
              <stop offset="100%" stopColor="#1CD4A7" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>

        <div style={{ display: 'flex', gap: 12, width: '100%' }}>
          {[
            { label: 'BTC/USDT', value: '$67,240', change: '+2.4%' },
            { label: 'ETH/USDT', value: '$3,841',  change: '+1.8%' },
            { label: '24h Volume', value: '$2.4B',  change: 'Live'  },
          ].map((s, i) => (
            <div key={i} style={{ flex: 1, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(28,212,167,0.15)', borderRadius: 12, padding: '12px 14px' }}>
              <div style={{ color: '#71717A', fontSize: 11, marginBottom: 4, fontFamily: "'DM Sans', sans-serif" }}>{s.label}</div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: 13, fontFamily: "monospace", letterSpacing: '-0.3px' }}>{s.value}</div>
              <div style={{ color: '#1CD4A7', fontSize: 11, marginTop: 3, fontWeight: 600 }}>{s.change}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom */}
      <div style={{ zIndex: 1 }}>
        <h2 style={{ color: '#fff', fontWeight: 800, fontSize: 22, margin: '0 0 8px', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3 }}>
          Trade Smarter.<br />Grow Faster.
        </h2>
        <p style={{ color: '#71717A', fontSize: 13, margin: 0, fontFamily: "'DM Sans', sans-serif" }}>
          Join thousands of traders on Bicoin's secure platform.
        </p>
      </div>
    </div>
  )
}
